var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Tag',{attrs:{"editable":true,"selectedTags":_vm.selectedTags},on:{"change":function (tag) {
      _vm.selectedTags.push(tag);
      this$1.$emit('update:selectedTags', _vm.selectedTags);
    },"delete":function (idx) {
      _vm.selectedTags.splice(idx, 1);
      this$1.$emit('update:selectedTags', _vm.selectedTags);
    }}})}
var staticRenderFns = []

export { render, staticRenderFns }